import { FormatPrice } from 'utils/format';

import { StyledCostMargin } from 'modules/assignment-cards/styled';

const DriverCost = ({ driver, fetchingJourneys, driverJourneys }) => {
  if (!driver) {
    return null;
  }
  const { carrier } = driver;
  const cost = driverJourneys.reduce((acc, { net_full_cost }) => acc + Number(net_full_cost), 0);

  if (fetchingJourneys) {
    return null;
  }

  return (
    <StyledCostMargin data-testid="driver_cost">
      <FormatPrice currency={carrier?.currency} value={cost} />
    </StyledCostMargin>
  );
};

export default DriverCost;
